import type { AssistantWorkspace } from "../ai-assistant";

export const aiAssistantFixture: AssistantWorkspace = {
  client: "Alfa S.r.l.",
  document: "Contratto di fornitura",
  documentStatus: "Bozza",
  version: "v1",
  initialMessages: [
    {
      id: "assistant-demo-request",
      role: "user",
      content: "Riepiloga il contratto e mostrami i punti da rivedere.",
      createdAt: "08:54",
      status: "complete",
    },
    {
      id: "assistant-demo-intro",
      role: "assistant",
      content: "Ho preparato un esempio di revisione. Puoi confrontare la proposta con il testo originale prima di applicarla.",
      createdAt: "08:54",
      status: "complete",
    },
  ],
  clauses: [
    {
      id: "durata-rinnovo",
      title: "Durata e rinnovo",
      article: "Art. 2 — Durata e rinnovo",
      original: "Il contratto ha durata annuale dalla data di sottoscrizione ed è rinnovato tacitamente per un ulteriore anno, salvo disdetta.",
      proposal: "Il contratto ha durata annuale dalla data di sottoscrizione. Il rinnovo richiede conferma scritta di entrambe le parti almeno 30 giorni prima della scadenza.",
      summary: "Chiarire il preavviso e valutare se mantenere il rinnovo tacito.",
    },
    {
      id: "tempi-consegna",
      title: "Tempi di consegna",
      article: "Art. 3 — Tempi di consegna",
      original: "Le parti concordano i tempi di consegna nell’ordine di fornitura.",
      proposal: "La consegna avverrà entro 15 giorni lavorativi dalla data di ricezione dell’ordine, salvo diversa pattuizione scritta tra le parti.",
      summary: "Aggiungere un termine chiaro e una modalità scritta per eventuali deroghe.",
    },
    {
      id: "modalita-pagamento",
      title: "Modalità di pagamento",
      article: "Art. 5 — Modalità di pagamento",
      original: "Il pagamento avverrà secondo le modalità concordate tra le parti.",
      proposal: "Il pagamento avverrà tramite bonifico bancario entro 30 giorni dalla data di ricezione della fattura, salvo diverso accordo scritto.",
      summary: "Specificare modalità e termine di pagamento, da confermare con il cliente.",
    },
  ],
};
